import { FC, useEffect, useState } from "react";

import {
	EnhancedDropDownRHFWithLabel,
	EnhancedTextAreaFieldRHF,
	LabelPosition,
	RHookFormDatePicker,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";
import { Box } from "@mui/material";
import { useNavigateToLogout } from "../../../common/Common";
import { CountryService } from "../../../services/common/CountryService";

interface IMinimumWageRateInfoSetupFieldsPanel {
	countryList: {
		shortCode?: string;
		label: string;
		value: string;
		countryType: string;
	}[];
	provinceDDLLoading: (value: boolean) => void;
	formMethods: any;
	provinceStateDDLinUpdate?: any;
	provinceDDLItems: any;
	provinceStateLabelinUpdate?: any;
}
export const MinimumWageRateInfoSetupFieldsPanel: FC<
	IMinimumWageRateInfoSetupFieldsPanel
> = ({
	countryList,
	provinceDDLLoading,
	formMethods,
	provinceStateDDLinUpdate,
	provinceDDLItems,
	provinceStateLabelinUpdate,
}) => {
	const navigateToLogout = useNavigateToLogout();

	const [provinceOrStateDDL, setprovinceOrStateDDL] = useState(undefined);
	const [countrytype, setCountrytype] = useState("Province");
	const [selectedCountryShortCode, setSelectedCountryShortCode] =
		useState<any>("");
	const [selectedCountry, setSelectedCountry] = useState<any>("");

	// const onCountryChangeHandler = async (e: any) => {

	// 		setSelectedCountryShortCode(e.shortCode);
	// 		setSelectedCountry(e.value)
	// 		let selected = e.value;
	// 		setCountrytype(
	// 			e.countryType === "province"
	// 				? "Province"
	// 				: e.countryType === "state"
	// 				? "State"
	// 				: e.countryType
	// 		);
	// 		formMethods.setValue("province", undefined);
	// 		formMethods.setValue("state", undefined);
	// 		try {
	// 			provinceDDLLoading(true);
	// 			const responce = await CountryService.getProvinceOrStateDDL(
	// 				navigateToLogout,
	// 				selected,
	// 				e.countryType
	// 			);
	// 			setprovinceOrStateDDL(responce);
	// 			provinceDDLItems(responce);
	// 		} catch {
	// 			
	// 		} finally {
	// 			provinceDDLLoading(false);
	// 		}
	// 	};

	useEffect(() => {
		// if (provinceStateDDLinUpdate && provinceStateLabelinUpdate) {

		// 	setprovinceOrStateDDL(provinceStateDDLinUpdate);
		// 	provinceDDLItems(provinceStateDDLinUpdate);
		// 	setCountrytype(
		// 		provinceStateLabelinUpdate === "province"
		// 			? "Province"
		// 			: provinceStateLabelinUpdate === "state"
		// 			? "State"
		// 			: provinceStateLabelinUpdate
		// 	);
		// }
		if (countryList) {
			const canada = countryList.find(
				(item: any) => item.label === "Canada" || "canada"
			);
			if (canada) {
				setSelectedCountryShortCode(canada.shortCode);
				setSelectedCountry(canada.value);
				(async () => {
					try {
						provinceDDLLoading(true);
						const response = await CountryService.getProvinceOrStateDDL(
							navigateToLogout,
							canada.value,
							"Province"
						);
						setprovinceOrStateDDL(response);
						provinceDDLItems(response);
					} catch (err) {
						console.error("error", err);
					} finally {
						provinceDDLLoading(false);
					}
				})();
			}
		}
	}, [provinceStateLabelinUpdate, provinceStateDDLinUpdate, countryList]);
	return (
		<Box
			sx={{
				padding: "0",
			}}
		>
			{provinceOrStateDDL && (
				<EnhancedDropDownRHFWithLabel
					selectName={"province"}
					label={countrytype}
					labelPosition={LabelPosition.Top}
					// required
					testId={`province-list`}
					items={provinceOrStateDDL ?? []}
					labelColumns={4}
					fieldColumns={8}
				/>
			)}
			<RHookFormTextFieldWithLabel
				label="Min Wage Rate"
				id="minWageRate"
				testId={`minWageRate`}
				labelPosition={LabelPosition.Top}
			/>
			<RHookFormDatePicker
				name="dateEffective"
				testId="dateEffective"
				label="Date effective"
				labelPosition={LabelPosition.Top}
				format="M dd, yy"
				// required
				labelColumns={4}
				fieldColumns={8}
			/>
			<EnhancedDropDownRHFWithLabel
				selectName={"type"}
				label={"Type"}
				labelPosition={LabelPosition.Top}
				// required
				testId={`province-list`}
				items={[
					{ label: "General", value: 400 },
					{ label: "First Job", value: 300 },
					{ label: "Entry Level [BC]", value: 200 },
					{ label: "Construction Workers [MB]", value: 100 },
					{ label: "Inexperienced Workers [NS]", value: 600 },
					{ label: "Students [ON]", value: 800 },
					{ label: "Liquor servers [ON]", value: 700 },
					{ label: "Homeworkers [ON]", value: 500 },
					{ label: "Worker Receiving Graduties [QC]", value: 900 },
				]}
				labelColumns={4}
				fieldColumns={8}
			/>
		</Box>
	);
};
